// AI-assisted Job Description helpers for the Opening form.
//
// Each summernote textarea is wrapped by a .ai-jd-group element that carries
// data-target="description" or "client_desc" so we know which field to read
// and write. Buttons inside the group POST to /openings/stream_description
// or /openings/rewrite_description with data-action / data-instruction
// attributes describing what to do. On success we drop the returned HTML into
// the corresponding summernote instance via .summernote('code', html).
//
// Uses AiStreamClient for streaming responses from the AI backend.

import AiStreamClient from './ai_stream_client';

function readForm(){
  var $f = $('form.simple_form, form.new_opening, form.edit_opening').first();
  if ($f.length === 0) $f = $('form').has('.summernote').first();
  return {
    title:       $f.find('#opening_title').val()       || '',
    location:    $f.find('#opening_location').val()    || '',
    client_name: $f.find('#opening_client_name').val() || '',
    client_desc: $f.find('#opening_client_desc').val() || '',
  };
}

function setBusy($btn, busy){
  if (busy){
    $btn.prop('disabled', true);
    $btn.data('orig-text', $btn.text());
    $btn.text($btn.data('busy-text') || '…');
  } else {
    $btn.prop('disabled', false);
    var t = $btn.data('orig-text');
    if (t) $btn.text(t);
  }
}

function noteWrite($group, html){
  var $ta = $group.find('textarea.summernote').first();
  if ($ta.length && $ta.data('summernote')){
    $ta.summernote('code', html);
  } else {
    // Summernote not initialized yet (unlikely on the form page). Fall back
    // to writing the raw HTML into the textarea; the editor will pick it up
    // when it initializes.
    $ta.val(html);
  }
}

function currentHtml($group){
  var $ta = $group.find('textarea.summernote').first();
  if ($ta.length && $ta.data('summernote')){
    return $ta.summernote('code');
  }
  return $ta.val() || '';
}

function showError($group, msg){
  var $err = $group.find('.ai-jd-error');
  if ($err.length === 0){
    $err = $('<div class="ai-jd-error alert alert-warning mt-2 mb-0"></div>');
    $group.append($err);
  }
  $err.text(msg).show();
  setTimeout(function(){ $err.fadeOut(300, function(){ $(this).remove(); }); }, 4000);
}

// When the server signals the monthly AI-token bucket is exhausted, disable
// every AI-JD button page-wide for the rest of the session and attach a
// tooltip. Non-AI recruiting features keep working normally. The banner near
// the button is dismissable but the disabled state persists — this matches
// the promise in the marketing FAQ (soft-degrade).
function disableAllAiButtons(msg){
  var $btns = $(document).find('.ai-jd-generate, .ai-jd-rewrite');
  $btns.prop('disabled', true).attr('title', msg).addClass('ai-quota-exhausted');
}

// Try to parse a server error response. Returns { message, quotaExceeded }.
function parseAjaxError(xhr){
  var out = { message: 'AI request failed.', quotaExceeded: false };
  try {
    var payload = JSON.parse(xhr.responseText || '{}');
    if (payload.error) out.message = payload.error;
    if (payload.quota_exceeded) out.quotaExceeded = true;
  } catch(_e){}
  // 429 without explicit flag: fall back to quota-exceeded UX if the message
  // looks like a quota message (defensive — we control both ends today).
  if (xhr.status === 429 && !out.quotaExceeded) {
    out.quotaExceeded = /token|quota|budget|额度|用完/i.test(out.message);
  }
  return out;
}

function onGenerate(e){
  e.preventDefault();
  var $btn   = $(this);
  var $group = $btn.closest('.ai-jd-group');
  var target = $group.data('target');
  var form   = readForm();

  var payload = {
    title:       form.title,
    location:    form.location,
    bullets:     $group.find('.ai-jd-bullets').val() || '',
    client_name: form.client_name,
    client_desc: target === 'client_desc' ? '' : form.client_desc,
  };

  if (!payload.title){
    showError($group, $group.data('no-title-msg') || 'Title is required.');
    return;
  }

  setBusy($btn, true);
  noteWrite($group, '');

  var accumulated = '';
  var client = new AiStreamClient('/openings/stream_description');

  client.stream(payload, {
    onChunk: function(data){
      var delta = typeof data === 'string' ? data : (data.text || data);
      accumulated += delta;
      noteWrite($group, accumulated);
    },
    onComplete: function(){
      setBusy($btn, false);
    },
    onError: function(error){
      setBusy($btn, false);
      showError($group, error.message || 'AI request failed.');
      if (error.code === 'RATE_LIMIT' || error.code === 'BUDGET'){
        disableAllAiButtons(error.message);
      }
    }
  });
}

function onRewrite(e){
  e.preventDefault();
  var $btn   = $(this);
  var $group = $btn.closest('.ai-jd-group');
  var instr  = $btn.data('instruction');
  var current = currentHtml($group);

  if (!current || !current.trim()){
    showError($group, $group.data('no-content-msg') || 'Nothing to rewrite yet.');
    return;
  }

  setBusy($btn, true);
  $.ajax({
    url:      '/openings/ai_rewrite_description',
    type:     'POST',
    dataType: 'json',
    data:     { current: current, instruction: instr },
    success:  function(resp){ noteWrite($group, resp.description); },
    error:    function(xhr){
      var parsed = parseAjaxError(xhr);
      showError($group, parsed.message);
      if (parsed.quotaExceeded) disableAllAiButtons(parsed.message);
    },
    complete: function(){ setBusy($btn, false); },
  });
}

function init(){
  // Delegated so the form partial can render buttons before or after this
  // module runs — order-independent.
  $(document)
    .off('click.aiJd', '.ai-jd-generate, .ai-jd-rewrite')
    .on('click.aiJd',  '.ai-jd-generate', onGenerate)
    .on('click.aiJd',  '.ai-jd-rewrite',  onRewrite);
}

$(document).ready(init);

export { init };
